import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = ({ showTrustIndicators = true }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="bg-gradient-to-br from-primary-50 to-white pt-16 min-h-screen flex items-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="animate-fade-in">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Your Business Brain.{' '}
              <span className="text-primary-600">Built on Your Terms.</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We connect your sales data, financials, documentation, and operational systems
              into a unified Intelligence Layer—powered by AI you own.
            </p>
            <p className="text-lg text-gray-500 mb-8">
              Get instant answers to complex business questions without surrendering your data.
              Choose your AI model (self-hosted or cloud-based under your agreement),
              and unlock the business intelligence you've been missing. By connecting your
              existing tools and data sources, we build a custom AI-powered brain that works for you.
              Most importantly, you retain full control over your data.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => {
                  scrollToSection('contact');
                  // Pre-fill the contact form subject
                  setTimeout(() => {
                    const subjectField = document.querySelector('select[name="subject"]');
                    if (subjectField) {
                      subjectField.value = 'Workflow Audit Request';
                    }
                  }, 100);
                }}
                className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 flex items-center justify-center group shadow-lg hover:shadow-xl"
              >
                Request Your Workflow Audit
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200"
              >
                See How It Works
              </button>
            </div>

            {/* Micro-copy under CTAs */}
            <p className="text-sm text-gray-500 mt-4">
              15-minute discovery call · No commitment · See how your data becomes decisions
            </p>

            {/* Trust indicators */}
            {showTrustIndicators && (
              <div className="mt-12 pt-8 border-t border-gray-200">
                <p className="text-sm text-gray-500 mb-4">Trusted by businesses like:</p>
                <div className="flex flex-wrap items-center gap-8">
                  <div className="bg-gray-100 px-6 py-3 rounded-lg text-gray-600 font-medium">
                    Company Name
                  </div>
                  <div className="bg-gray-100 px-6 py-3 rounded-lg text-gray-600 font-medium">
                    Business Inc.
                  </div>
                  <div className="bg-gray-100 px-6 py-3 rounded-lg text-gray-600 font-medium">
                    Corp Solutions
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Hero Image/Visual */}
          <div className="animate-slide-in">
            <div className="bg-gradient-to-br from-primary-200 to-primary-100 rounded-2xl h-96 lg:h-[500px] flex items-center justify-center shadow-2xl">
              <img 
                src="/GSCS_oldman_black.png" 
                alt="GSCS Professional Services" 
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('services')}
          className="p-2 rounded-full bg-white shadow-lg hover:shadow-xl transition-shadow"
          aria-label="Scroll to services"
        >
          <ArrowRight className="h-6 w-6 text-primary-600 rotate-90" />
        </button>
      </div>
    </section>
  );
};

export default Hero;